// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"MccFooter_footerLink__FHuBP","footer":"MccFooter_footer__YUVdU"};